export default {
  apiKey: 'AIzaSyBTkI--qkSzS7ODNKHxGHk8YHQ1lXvK9IE',
  authDomain: 'asianallance.firebaseapp.com',
  databaseURL: 'https://asianallance-default-rtdb.asia-southeast1.firebasedatabase.app',
  projectId: 'asianallance',
  storageBucket: 'asianallance.appspot.com',
  messagingSenderId: '950298184525',
  appId: '1:950298184525:web:308c6b13e0ce20b5324504',
  measurementId: 'G-CRCYXM4TQH',
}
